import React, { useState } from 'react'
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Checkbox,
  HStack,
  Stack
} from '@chakra-ui/react'

import axios from 'lib/axios'

import InfoHint from '../components/InfoHint'
import { getErrorMessage } from '../types'

type Props = {
  statementEndDate: string
}

const LiveSend = ({ statementEndDate }: Props) => {
  const [confirmedTestSend, setConfirmedTestSend] = useState(false)
  const [confirmedBuildiumImpact, setConfirmedBuildiumImpact] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const canSend = confirmedTestSend && confirmedBuildiumImpact

  const onSend = async () => {
    try {
      setIsLoading(true)
      setError('')
      setSuccess('')

      await axios.post('/admin/system/topic_publish', {
        topic: 'calculator-send-monthly-statements',
        message: {
          isLiveSend: true,
          statementEndDate
        }
      })

      setSuccess('Live send triggered.')
    } catch (err: any) {
      setError(getErrorMessage(err))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <Stack spacing={3}>
      <Alert status='error'>
        <AlertIcon />
        <Stack>
          <AlertTitle>High stakes action</AlertTitle>
          <AlertDescription>
            This sends real customer emails and creates Buildium journal entries.
          </AlertDescription>
        </Stack>
      </Alert>

      <HStack spacing={1} alignItems='center'>
        <Checkbox
          isChecked={confirmedTestSend}
          onChange={(event) => setConfirmedTestSend(event.target.checked)}
        >
          I completed the test send and verified counts in logs
        </Checkbox>
        <InfoHint label='Safety confirmation that a test send was run and reviewed before any live publish.' />
      </HStack>
      <HStack spacing={1} alignItems='center'>
        <Checkbox
          isChecked={confirmedBuildiumImpact}
          onChange={(event) => setConfirmedBuildiumImpact(event.target.checked)}
        >
          I understand this will create Buildium journal entries
        </Checkbox>
        <InfoHint label='Live sends create Buildium journal entry side effects. This confirmation reduces accidental repeats.' />
      </HStack>

      <HStack spacing={1} alignSelf='flex-start' alignItems='center'>
        <Button
          colorScheme='red'
          onClick={onSend}
          isDisabled={!canSend || isLoading || !statementEndDate}
          alignSelf='flex-start'
        >
          Send Live Statements
        </Button>
        <InfoHint label='Publishes a live message to topic calculator-send-monthly-statements with isLiveSend=true, which sends customer emails and downstream Buildium entries.' />
      </HStack>

      {error && (
        <Alert status='error'>
          <AlertIcon />
          <AlertDescription>{error}</AlertDescription>
        </Alert>
      )}
      {success && (
        <Alert status='success'>
          <AlertIcon />
          <AlertDescription>{success}</AlertDescription>
        </Alert>
      )}
    </Stack>
  )
}

export default LiveSend
